import { render, staticRenderFns } from "./QuoteAndDraft.vue?vue&type=template&id=0445c97e&scoped=true"
import script from "./QuoteAndDraft.vue?vue&type=script&lang=js"
export * from "./QuoteAndDraft.vue?vue&type=script&lang=js"
import style0 from "./QuoteAndDraft.vue?vue&type=style&index=0&id=0445c97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445c97e",
  null
  
)

export default component.exports